import React from 'react';
import clsx from 'clsx';

interface AllGroupsCardProps {
	groupCount: number;
	isActive: boolean;
	onSelect: () => void;
}

export const AllGroupsCard: React.FC<AllGroupsCardProps> = ({ groupCount, isActive, onSelect }) => {
	return (
		<button
			type="button"
			className={clsx('group-card group-card--all', { 'group-card--active': isActive })}
			onClick={onSelect}>
			<span className="group-card__icon">
				<i className="icons-users-group-rounded" />
			</span>
			<div className="group-card__all-text">
				<span className="group-card__name">Tüm Gruplar</span>
				<span className="group-card__count">{groupCount} Grup</span>
			</div>
		</button>
	);
};

export default AllGroupsCard;
